import { domainSchema } from '@/features/settings/domain-input';

export const normalizeMeetingSiteHost = (input: string): string | null => {
  const parsed = domainSchema.safeParse(input);
  return parsed.success ? parsed.data : null;
};

export const normalizeMeetingSiteHosts = (raw: unknown): string[] => {
  if (!Array.isArray(raw)) return [];

  const hosts = raw
    .filter((value): value is string => typeof value === 'string')
    .map(normalizeMeetingSiteHost)
    .filter((host): host is string => host !== null);

  return [...new Set(hosts)];
};
